import React from 'react'

export default function Hero() {
    return (
        <>
          <section className="section parallax bg1 hero-section hero-me" >
            <div className="hero-text">
                <h2>New Games & Accessories</h2>
               <h3>Monthly packages.</h3>
                <h3>Excitement delivered daily.</h3>
               <p>What's the best way to shop for the latest video games and peripherals? How about never shopping at all? <br/>
                You'll get new stuff on your doorstep -- every month.</p>
                <button className="button call-btn">Get started</button>
         </div>
         </section>
         {/* <section className="section parallax2 bg2 hero-section hero-me afterbg bg2better" style={{zIndex:"-10"}}>
         </section> */}
         {/* <div className="bottombg"></div> */}

        </>
    )
}
